import React from "react";

const PlayerOverlayButton = ({
    className,
    position = {},
    onClick,
    iconSrc,
    alt,
    iconSize = { width: "30px", height: "30px" },
    zIndex = 2,
    loading = "lazy"
}) => {
    const defaultStyles = {
        position: "absolute",
        zIndex: zIndex,
        cursor: "pointer",
        ...position
    };

    return (
        <div
            className={className}
            style={defaultStyles}
            onClick={onClick}
        >
            <img
                src={iconSrc}
                alt={alt}
                style={iconSize}
                loading={loading}
            />
        </div>
    );
};

export default PlayerOverlayButton;
